import React, { Component, Fragment, useState } from "react";
import { withStyles } from "@mui/styles";
import CustomizedSnackbar from "../../../../../components/CustomizedSnackbar/CustomizedSnackbar";
import LoginMenu from "../../../../../components/LoginMenu/LoginMenu";
import {Divider, IconButton, Tooltip, CircularProgress, Grid, Typography, 
  Button} from "@mui/material";
  import { Dialog, DialogContent } from "@mui/material";
import { format } from "date-fns";
import FilterIcon from "@mui/icons-material/FilterList";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import F113FormTable from "./F113FormTable";
import { useDropzone } from "react-dropzone";

const styles = ({
  
});

function MyDropzone(props) {

  const [isFileSelected, setIsFileSelected] = useState(false);
 
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({ accept: 'application/pdf, text/plain, application/vnd.oasis.opendocument.text, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document', multiple:false });

  const files = acceptedFiles.map((file, index) => {
    const size = file.size > 0 ? (file.size / 1000).toFixed(2) : file.size;
    if(!isFileSelected){ 
      setIsFileSelected(true);
      setTimeout(()=>{
        props.onFormSubmit("form"+props.index);
      }, 250);
    }
    return (
        <Typography key={index} variant="subtitle1" color="primary">
            {/* {file.path} - {size} Kb */}
            <input type="hidden" name="file_name" value={file.path}></input>
        </Typography>
    );
  });

  let msg = files || [];
  if(msg.length<=0) {
      //msg = <Typography variant="subtitle1">Please click here to  select and upload an file</Typography>;
      msg = (
              (<Button 
                variant="outlined" 
                color="primary" 
                size="small"
              >Submit
                              </Button>)
            // <Tooltip title="Upload">
            //   <IconButton  
            //     aria-label="Upload"
            //   >
            //     <CloudUploadOutlinedIcon color="primary"/>
            //   </IconButton>
            // </Tooltip>
      );
  }
  
  return (
      <Fragment>
        {isFileSelected && <Fragment><CircularProgress size={24} /></Fragment>}
        <form id={"form"+props.index} hidden={isFileSelected} style={{display:"inline-block"}}>
          <div
            style={{ textAlign: "center"}}
            {...getRootProps({ className: "dropzone", onChange: event => props.onChange(event) })}
          >
            <input name="examId" type="hidden" value={props.examId} />
            <input name="sectionId" type="hidden" value={props.sectionId} />
            <input name="contained-button-file" {...getInputProps()} disabled={props.disabled} />
            {msg}
          </div>
        </form>
      </Fragment>
  );
}

class F113Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isExamLoading: false,
      showTableFilter: false,
      showSearchBar: false,
      isDownloadExcel: false,
      isLoginMenu: false,
      isReload: false,
      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
      uploadLoading:false,
      files: [],
      tableData: []
    };
  }

  handleOpenSnackbar = (msg, severity) => {
    this.setState({
      isOpenSnackbar: true,
      snackbarMessage: msg,
      snackbarSeverity: severity,
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      isOpenSnackbar: false,
    });
  };

  handleFileChange = event => {
    const { files = [] } = event.target;
    if (files.length==1) {
        if ( (files[0].type === "application/pdf" || files[0].type === "text/plain" || files[0].type === "application/vnd.oasis.opendocument.text" || files[0].type === "application/msword" || files[0].type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") && files[0].size/1000<10000) {
            this.setState({
                files,
                filesError: ""
            });
        }else {
            this.handleOpenSnackbar("Please select only pdf, txt, odt, doc or docx file with size less than 10 MBs.","error");
        }
    } else {
      this.handleOpenSnackbar("Please select only one file at a time.","error");
    }
  }

  getData = async () => {
    this.setState({isLoading: true});
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C113CommonAcademicsExamsView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({Authorization: "Bearer "+localStorage.getItem("lmsToken")}),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            let data = json.DATA || [];
            let dataLength = data.length;
            for (let i=0; i<dataLength; i++) {
              
              let fileName = data[i].fileName;
              let fileUrl = data[i].fileUrl;
              let isValidDownloadExam = data[i].isValidDownloadExam;
              data[i].fileDownload = (
                <Fragment>
                  {isValidDownloadExam ? 
                    this.state.isExamLoading ?
                      ""
                      :
                      <Tooltip title="Download">
                        <IconButton
                          onClick={(e)=>this.downloadFile(e, fileUrl, fileName)}
                          aria-label="download"
                          size="large">
                          <CloudDownloadIcon color="primary" />
                        </IconButton>
                      </Tooltip>
                  :
                  <IconButton disabled={true} aria-label="download" size="large">
                    <CloudDownloadIcon />
                  </IconButton>
                  }
                </Fragment>
              );

              let sectionId = data[i].sectionId;
              let examId = data[i].id;
              let isValidEndDate = data[i].isValidDueDate;
              let isAnswerSheetUploaded = data[i].isStudentExamFileAlreadyUploaded;
              data[i].answerSheet = (
                <Fragment>
                  {//isValidEndDate && !isAnswerSheetUploaded ?
                  isValidEndDate ?
                      <MyDropzone
                        index={i}
                        files={this.state.files} 
                        onChange={event => this.handleFileChange(event)} 
                        disabled={this.state.uploadLoading}
                        onFormSubmit={this.onFormSubmit}
                        sectionId={sectionId}
                        examId={examId}
                      />
                    :
                    <Fragment>
                      <Button 
                        variant="outlined" 
                        size="small"
                        disabled={true}
                      >
                        Submit
                      </Button>
                    </Fragment>
                  }
                </Fragment>
              );
              
              let studentExamFileName = data[i].studentExamFileName;
              let studentExamFileUrl = data[i].studentExamFileUrl;
              data[i].answerSheetDownload = (
                studentExamFileName ? 
                  <Tooltip title="Download">
                    <IconButton
                      onClick={(e)=>this.downloadFile(e, studentExamFileUrl, studentExamFileName)}
                      aria-label="download"
                      size="large">
                      <CloudDownloadIcon style={{color:"#4caf50"}} />
                    </IconButton>
                  </Tooltip> 
                :
                ""
              );

              let gradedExamFileUrl = data[i].gradedExamFileUrl;
              let gradedExamFileName = data[i].gradedExamFileName;
              data[i].gradedExamUrl = (
                gradedExamFileUrl ? 
                <Fragment>
                  <Tooltip title="Download">
                    <IconButton
                      onClick={(e)=>this.downloadFile(e, gradedExamFileUrl, gradedExamFileName)}
                      aria-label="download"
                      size="large">
                      <CloudDownloadIcon color="primary" />
                    </IconButton>
                    </Tooltip>
                </Fragment>
                :
                ""
              );

            }
            this.setState({tableData: data || []});
          } else {
            //alert(json.SYSTEM_MESSAGE + '\n' + json.USER_MESSAGE);
            this.handleOpenSnackbar(<span>{json.SYSTEM_MESSAGE}<br/>{json.USER_MESSAGE}</span>,"error");
          }
          console.log("getData", json);
        },
        (error) => {
          if (error.status === 401) {
            this.setState({
              isLoginMenu: true,
              isReload: true,
            });
          } else {
            //alert('Failed to fetch, Please try again later.');
            this.handleOpenSnackbar("Failed to fetch, Please try again later.","error");
            console.log(error);
          }
        }
      );
    this.setState({isLoading: false});
  };

  downloadFile = async(e, fileUrl, fileName, viewOnly=false) => {
      e.preventDefault();
      this.setState({ isExamLoading: true });
      let data = new FormData();
      data.append("fileName", fileUrl);
      const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/CommonViewFile`;
      await fetch(url, {
          method: "POST",
          body: data,
          headers: new Headers({
              Authorization: "Bearer "+localStorage.getItem("lmsToken"),
          }),
      })
      .then((res) => {
          if (res.status === 200) {
              return res.blob();
          } else if (res.status === 401) {
              this.setState({
                  isLoginMenu: true,
                  isReload: false
              })
              return {}
          } else {
              alert('Operation Failed, Please try again later.');
              return {}
          }
      })
      .then((result) => {

        if(viewOnly) {
          let fileExtension = fileName.slice((Math.max(0, fileName.lastIndexOf(".")) || Infinity) + 1);
          let fileMimeType = result.type;
          if(fileExtension==="doc" || fileExtension==="DOC"){
            fileMimeType = "application/msword";
          }else if(fileExtension==="pdf" || fileExtension==="PDF") {
            fileMimeType = "application/pdf"
          }else if(fileExtension==="docx" || fileExtension==="DOCX"){
            fileMimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
          }
          let blob = new Blob([result], { type: fileMimeType });
          if (blob) {
              let fileURL = window.URL.createObjectURL(blob);
              window.open(fileURL);
          }
        } else {
          let fileUrl = window.URL.createObjectURL(result);
          let tempLink = document.createElement("a");
          tempLink.href = fileUrl;
          tempLink.setAttribute("download", fileName);
          tempLink.click();
        }

        if(result.type!="application/json"){
          this.handleOpenSnackbar("Operation Failed, Please try again later.","error");
        }
        
        if (result.CODE === 1) {
            //Code
        } else if (result.CODE === 2) {
            alert("SQL Error (" +result.CODE +"): " +result.USER_MESSAGE +"\n" +result.SYSTEM_MESSAGE);
        } else if (result.CODE === 3) {
            alert("Other Error ("+result.CODE+"): " +result.USER_MESSAGE +"\n" +result.SYSTEM_MESSAGE);
        } else if (result.error === 1) {
            alert(result.error_message);
        } else if (result.success === 0 && result.redirect_url !== "") {
            window.location = result.redirect_url;
        }
    })
    .catch((error) => {
        console.log(error);
    });
    this.setState({ isExamLoading: false });
  };

  onFormSubmit = async (formId) => {
    if ( !this.isFileValid() ) { return; }
    let myForm = document.getElementById(formId);
    const data = new FormData(myForm);
    this.setState({ isLoading: true });
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C113CommonAcademicsExamsStudentsSave`;
    await fetch(url, {
      method: "POST",
      body: data,
      headers: new Headers({Authorization:"Bearer "+localStorage.getItem("lmsToken")}),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            this.handleOpenSnackbar(json.USER_MESSAGE, "success");
            setTimeout(() => {
                window.location.reload();
            }, 1000);
          } else {
            this.handleOpenSnackbar(<span>{json.SYSTEM_MESSAGE}+<br/>+{json.USER_MESSAGE}</span>,"error");
          }
          console.log(json);
        },
        (error) => {
          if (error.status == 401) {
            this.setState({
              isLoginMenu: true,
              isReload: true,
            });
          } else {
            console.log(error);
            this.handleOpenSnackbar("Failed to Save ! Please try Again later.","error");
          }
        }
      );
    this.setState({ isLoading: false });
  };

  onHandleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleToggleTableFilter = () => {
    this.setState({ showTableFilter: !this.state.showTableFilter });
  };

  handleToggleSearchBar = () => {
    this.setState({ showSearchBar: !this.state.showSearchBar });
  };

  isFileValid = () => {
    let isValid = true;
    if (this.state.files.length<1 && this.state.recordId==0) {
      this.handleOpenSnackbar("Please select file.","error");
      isValid = false;
    } else {
      this.setState({ filesError: "" });
    }
    return isValid;
  };

  componentDidMount() {
    this.props.setDrawerOpen(false);
    this.getData();
  }

  render() {

    const {classes} = this.props;

    const columns = [
      //{ name: "SRNo", title: "SR#" },
      { name: "label", title: "Title" },
      { name: "startDate", title: "Start On" },
      { name: "endDate", title: "End On" },
      { name: "instruction", title: "Instruction" },
      { name: "fileDownload", title: "Exam" },      
      { name: "totalMarks", title: "Total\xa0Marks" },
      { name: "answerSheet", title: "Answer\xa0Sheet" },
      { name: "answerSheetDownload", title: "Download Answer\xa0Sheet" },
      { name: "uploadedOn", title: "Uploaded\xa0On" },
      { name: "obtainedMarks", title: "Obtained Marks"},
      { name: "gradedExamUrl", title: "Graded Exam"},
      { name: "remarks", title: "Teacher\xa0Remarks" }
    ];

    return (
      <Fragment>
        <Dialog
          open={this.state.isExamLoading}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "lightgrey"
            }}
          >
            <CircularProgress />
            <span
              style={{
                marginTop: 15,
                marginBottom: 15,
              }}
            >
              Please Wait...
            </span>
          </DialogContent>
        </Dialog>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <div style={{padding:20}}>
          <Grid 
            container
            justifyContent="space-between"
            spacing={2}
          >
            <Typography
              style={{
                color: "#1d5f98",
                fontWeight: 600,
                textTransform: "capitalize",
              }}
              variant="h5"
            >
              <Tooltip title="Back">
                <IconButton onClick={() => window.history.back()} size="large">
                  <ArrowBackIcon fontSize="small" color="primary" />
                </IconButton>
              </Tooltip>
              Exams
            </Typography>
            <div style={{ float: "right" }}>
              <Tooltip title="Table Filter">
                <IconButton
                  style={{ marginLeft: "-10px" }}
                  onClick={this.handleToggleTableFilter}
                  size="large">
                  <FilterIcon fontSize="default" color="primary" />
                </IconButton>
              </Tooltip>
            </div>
          </Grid>
          <Divider
            style={{
              backgroundColor: "rgb(58, 127, 187)",
              opacity: "0.3",
            }}
          />
          <br />
          {this.state.tableData ? 
            <F113FormTable
              data={this.state.tableData}
              columns={columns}
              showFilter={this.state.showTableFilter}
            />
            : this.state.isLoading && 
            <Grid container justifyContent="center" alignItems="center">
              <CircularProgress />
            </Grid>
          }
          <CustomizedSnackbar
            isOpen={this.state.isOpenSnackbar}
            message={this.state.snackbarMessage}
            severity={this.state.snackbarSeverity}
            handleCloseSnackbar={() => this.handleCloseSnackbar()}
          />
        </div>
      </Fragment>
    );
  }
}
export default withStyles(styles)(F113Form);
